const AnalysisStudyListConstants = {
  SET_ROUTE_CONTEXT: "analysisStudyList/SET_ROUTE_CONTEXT",
  LOADED_STUDIES_FOR_STEP_ID: "analysisStudyList/LOADED_STUDIES_FOR_STEP_ID",
  LOADING_STUDY_ABSTRACTS_FOR_STEP_ID: "analysisStudyList/LOADING_STUDY_ABSTRACTS_FOR_STEP_ID",
  LOADED_STUDY_ABSTRACTS_FOR_STEP_ID: "analysisStudyList/LOADED_STUDY_ABSTRACTS_FOR_STEP_ID",
  LOAD_STUDIES_FOR_STUDY_IDS: "analysisStudyList/LOAD_STUDIES_FOR_STUDY_IDS",
  LOAD_STUDY_FOR_STUDY_ID: "analysisStudyList/LOAD_STUDY_FOR_STUDY_ID",
  LOADING_STUDY: "analysisStudyList/LOADING_STUDY",
  LOADED_STUDY: "analysisStudyList/LOADED_STUDY",
  LOAD_FORAY_CONFIG_METADATA: "analysisStudyList/LOAD_FORAY_CONFIG_METADATA",
  LOADING_FORAY_CONFIG_METADATA: "analysisStudyList/LOADING_FORAY_CONFIG_METADATA",
  LOADED_FORAY_CONFIG_METADATA: "analysisStudyList/LOADED_FORAY_CONFIG_METADATA",
  LOAD_ANALYSIS_STEP_PROPERTIES: "analysisStudyList/LOAD_ANALYSIS_STEP_PROPERTIES",
  LOADING_ANALYSIS_STEP_PROPERTIES: "analysisStudyList/LOADING_ANALYSIS_STEP_PROPERTIES",
  LOADED_ANALYSIS_STEP_PROPERTIES_LEGACY: "analysisStudyList/LOADED_ANALYSIS_STEP_PROPERTIES_LEGACY",
  LOADED_ANALYSIS_STEP_PROPERTIES: "analysisStudyList/LOADED_ANALYSIS_STEP_PROPERTIES",
  ENABLE_STUDY: "analysisStudyWrite/ENABLE_STUDY",
  DISABLE_STUDY: "analysisStudyWrite/DISABLE_STUDY",
  DELETE_STUDY: "analysisStudyWrite/DELETE_STUDY",
  STUDY_STATE_UPDATING: "analysisStudyWrite/STUDY_STATE_UPDATING",
  SET_STUDY_ENABLED: "analysisStudyWrite/SET_STUDY_ENABLED",
  SET_STUDY_DISABLED: "analysisStudyWrite/SET_STUDY_DISABLED",
  SET_STUDY_DELETED: "analysisStudyWrite/SET_STUDY_DELETED",
  LOAD_RAW_STUDY: "analysisStudyRead/LOAD_RAW_STUDY",
  LOADING_RAW_STUDY: "analysisStudyRead/LOADING_RAW_STUDY",
  LOADED_RAW_STUDY: "analysisStudyRead/LOADED_RAW_STUDY",
  TOGGLE_SHOW_FORAY_PARAMETER: "analysisStudyRead/TOGGLE_SHOW_FORAY_PARAMETER",
  // https://exp.microsoft.com/api/analysis/steps/337e0f8b-f98c-4557-88df-eac62d5651c1/studyAbstracts?includeTasks=true&json
  V2_LOAD_STUDY_ABSTRACTS_FOR_STEP_ID: "analysisStudyList/V2_LOAD_STUDY_ABSTRACTS_FOR_STEP_ID",
  V2_LOADING_STUDY_ABSTRACTS_FOR_STEP_ID: "analysisStudyList/V2_LOADING_STUDY_ABSTRACTS_FOR_STEP_ID",
  V2_LOADED_STUDY_ABSTRACTS_FOR_STEP_ID_LEGACY: "analysisStudyList/V2_LOADED_STUDY_ABSTRACTS_FOR_STEP_ID_LEGACY",
  V2_LOADED_STUDY_ABSTRACTS_FOR_STEP_ID: "analysisStudyList/V2_LOADED_STUDY_ABSTRACTS_FOR_STEP_ID",
  // https://exp.microsoft.com/api/analysis/steps/fc196415-52c4-4125-8994-6a005fae0892/studyAbstracts/1755008?json&includeTasks=true
  V2_LOAD_STUDY_ABSTRACT: "analysisStudyList/V2_LOAD_STUDY_ABSTRACT",
  V2_LOADING_STUDY_ABSTRACT: "analysisStudyList/V2_LOADING_STUDY_ABSTRACT",
  V2_LOADED_STUDY_ABSTRACT: "analysisStudyList/V2_LOADED_STUDY_ABSTRACT",
  // https://exp.microsoft.com/api/analysis/tasks/9276135/logs?includePipelineJournalLogs=true&json
  V2_LOAD_TASK_LOGS: "analysisStudyList/V2_LOAD_TASK_LOGS",
  V2_LOADING_TASK_LOGS: "analysisStudyList/V2_LOADING_TASK_LOGS",
  V2_LOADED_TASK_LOGS: "analysisStudyList/V2_LOADED_TASK_LOGS",
  // https://exp.microsoft.com/api/analysis/scorecards/taskOverviewInfo?scorecardIds=90946823
  LOAD_TASK_OVERVIEW_INFO_FOR_SCORECARDID: "analysisStudyList/LOAD_TASK_OVERVIEW_INFO_FOR_SCORECARDID",
  LOADING_TASK_OVERVIEW_INFO_FOR_SCORECARDID: "analysisStudyList/LOADING_TASK_OVERVIEW_INFO_FOR_SCORECARDID",
  LOADED_TASK_OVERVIEW_INFO_FOR_SCORECARDID: "analysisStudyList/LOADED_TASK_OVERVIEW_INFO_FOR_SCORECARDID",
  REGISTER_ANALYSIS_FOR_STEP: "analysisStudyList/REGISTER_ANALYSIS_FOR_STEPD",
  REGISTERING_ANALYSIS_FOR_STEP: "analysisStudyList/REGISTERING_ANALYSIS_FOR_STEPD",
  REGISTERED_ANALYSIS_FOR_STEP: "analysisStudyList/REGISTERED_ANALYSIS_FOR_STEPD",
  V2_LOADED_WORKSPACE_REDIRECT: "analysisStudyList/V2_LOADED_WORKSPACE_REDIRECT"
};
export {
  AnalysisStudyListConstants as default
};
//# sourceMappingURL=AnalysisStudyListConstants.js.map
